import Vue from "vue";

const formatModelCurrency = ( value, precision = 4 ) => {
  if (!value) return '';
  const isNegative = value[0] === '-';
  if (isNegative) value = value.slice(1);
  value = value.replace(/[.,]/g, ".");
  const firstDotPosition = value.indexOf('.');
  value = value.replace(/[^0-9]/g, "");
  if (firstDotPosition === 0) value = '0.' + value;
  if (firstDotPosition > 0) value = value.substr(0, firstDotPosition) + "." + value.substr(firstDotPosition, precision);
  if (isNegative) value = '-' + value;
  return value;
};

Vue.directive('currency', {
  bind( el, binding, vnode ) {
    el.addEventListener("input", e => {
      const formatted = formatModelCurrency(e.target.value, binding.value);
      vnode.data.model.callback(formatted);
    });
  },
});
